// Mirrors backend: core/workflow/incept/Ppsr/Enums/CollateralClassType.php
export enum CollateralClassType {
  Unsupported = 'unsupported',
  Unknown = 'unknown',
  MotorVehicle = 'motor_vehicle',
  Watercraft = 'watercraft',
  Aircraft = 'aircraft',
  AircraftEngine = 'aircraft_engine',
  Airframe = 'airframe',
  Helicopter = 'helicopter',
  SmallAircraft = 'small_aircraft',
  Agriculture = 'agriculture',
  Crops = 'crops',
  Livestock = 'livestock',
  OtherGoods = 'other_goods',
  ChattelPaper = 'chattel_paper',
  Currency = 'currency',
  DocumentOfTitle = 'document_of_title',
  IntermediatedSecurity = 'intermediated_security',
  InvestmentInstrument = 'investment_instrument',
  NegotiableInstrument = 'negotiable_instrument',
  Account = 'account',
  GeneralIntangible = 'general_intangible',
  IntellectualProperty = 'intellectual_property',
  CircuitLayout = 'circuit_layout',
  Copyright = 'copyright',
  Patent = 'patent',
  Design = 'design',
  TradeMark = 'trade_mark',
  PlantBreedersRight = 'plant_breeders_right',
  AllPapNoExcept = 'all_pap_no_except',
  AllPapWithExcept = 'all_pap_with_except',
}

export const COLLATERAL_CLASS_TYPE_LABELS: Record<CollateralClassType, string> =
  {
    [CollateralClassType.Unsupported]: 'Unsupported',
    [CollateralClassType.Unknown]: 'Unknown',
    [CollateralClassType.MotorVehicle]: 'Motor Vehicle',
    [CollateralClassType.Watercraft]: 'Watercraft',
    [CollateralClassType.Aircraft]: 'Aircraft',
    [CollateralClassType.AircraftEngine]: 'Aircraft Engine',
    [CollateralClassType.Airframe]: 'Airframe',
    [CollateralClassType.Helicopter]: 'Helicopter',
    [CollateralClassType.SmallAircraft]: 'Small Aircraft',
    [CollateralClassType.Agriculture]: 'Agriculture',
    [CollateralClassType.Crops]: 'Crops',
    [CollateralClassType.Livestock]: 'Livestock',
    [CollateralClassType.OtherGoods]: 'Other Goods',
    [CollateralClassType.ChattelPaper]: 'Chattel Paper',
    [CollateralClassType.Currency]: 'Currency',
    [CollateralClassType.DocumentOfTitle]: 'Document Of Title',
    [CollateralClassType.IntermediatedSecurity]: 'Intermediated Security',
    [CollateralClassType.InvestmentInstrument]: 'Investment Instrument',
    [CollateralClassType.NegotiableInstrument]: 'Negotiable Instrument',
    [CollateralClassType.Account]: 'Account',
    [CollateralClassType.GeneralIntangible]: 'General Intangible',
    [CollateralClassType.IntellectualProperty]: 'Intellectual Property',
    [CollateralClassType.CircuitLayout]: 'Circuit Layout',
    [CollateralClassType.Copyright]: 'Copyright',
    [CollateralClassType.Patent]: 'Patent',
    [CollateralClassType.Design]: 'Design',
    [CollateralClassType.TradeMark]: 'Trade Mark',
    [CollateralClassType.PlantBreedersRight]: 'Plant Breeders Right',
    [CollateralClassType.AllPapNoExcept]: 'All Pap No Except',
    [CollateralClassType.AllPapWithExcept]: 'All Pap With Except',
  };
